import { Header, Footer } from "./Pricing";

export default function Terms() {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-16 prose prose-stone">
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-emerald-700">Legal</div>
        <h1 className="mt-3 font-display text-4xl font-medium text-stone-900">Terms of Service</h1>
        <p className="text-sm text-stone-500">Last updated: February 19, 2026</p>

        <h2>1. Acceptance of terms</h2>
        <p>By accessing or using ChildCheckOh ("Service"), operated by ChildCheckOh, you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

        <h2>2. Who can use the service</h2>
        <p>The Service is intended for licensed childcare centers, owners, directors, staff, and parents in the State of Ohio. You must be at least 18 years old and authorized to act on behalf of your center to register an owner account.</p>

        <h2>3. Account and security</h2>
        <p>You are responsible for safeguarding your password and your vault passcodes (which protect Records, Staff Docs, Licensing, and Billing). You agree to notify us immediately at <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a> of any unauthorized access.</p>

        <h2>4. Subscription, billing, and payment</h2>
        <p>The Service is offered on a paid monthly subscription. Plans, fees, and features are described on our <a href="/pricing">Pricing page</a>. Payments are processed by <b>PayPal</b>. By subscribing, you agree to PayPal&apos;s <a href="https://www.paypal.com/us/legalhub/useragreement-full" target="_blank" rel="noopener noreferrer">User Agreement</a> in addition to these Terms.</p>
        <p>You authorize us (via PayPal Subscriptions) to charge your payment method on the same day each month until you cancel. You may cancel at any time from your PayPal account or by emailing <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a>. Failed payments may result in suspension of access until the balance is cleared — PayPal will retry the charge automatically per your subscription settings.</p>

        <h2>5. Cancellation</h2>
        <p>You can cancel any time from your dashboard. Cancellation takes effect at the end of your current billing period. See our <a href="/refund">Refund Policy</a> for details on refunds.</p>

        <h2>6. Acceptable use</h2>
        <p>You agree not to (a) upload content that violates anyone's privacy or copyright, (b) attempt to reverse-engineer or compromise the Service, (c) use the Service to send unsolicited bulk email, or (d) use the Service for any unlawful purpose.</p>

        <h2>7. Your content</h2>
        <p>You retain ownership of all content you upload (child records, staff documents, licensing files, etc.). You grant ChildCheckOh a limited license to store, process, and display your content solely to operate the Service for you. We will never sell or share your data — see our <a href="/privacy">Privacy Policy</a>.</p>

        <h2>8. Compliance</h2>
        <p>ChildCheckOh helps you maintain Ohio DCY compliance, but you remain solely responsible for your center&apos;s regulatory obligations. The Service is a tool, not legal advice.</p>

        <h2>9. Service availability</h2>
        <p>We aim for 99.9% uptime but do not guarantee uninterrupted access. Scheduled maintenance may occur with advance notice. We are not liable for downtime caused by third-party services (hosting, email, payment processor).</p>

        <h2>10. Intellectual property</h2>
        <p>The ChildCheckOh name, logo, software, and design are owned by ChildCheckOh. You may not copy, modify, or distribute any part of the Service without written permission.</p>

        <h2>11. Termination</h2>
        <p>We reserve the right to suspend or terminate accounts that violate these Terms or engage in abusive behavior. On termination, you can export your data within 30 days at no extra cost.</p>

        <h2>12. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, ChildCheckOh's total liability for any claim is limited to the amount you paid in the 12 months before the claim arose. We are not liable for indirect, consequential, or punitive damages.</p>

        <h2>13. Changes to these terms</h2>
        <p>We may update these Terms from time to time. Material changes will be emailed to your owner address with at least 30 days' notice. Continued use after the effective date means you accept the new terms.</p>

        <h2>14. Governing law</h2>
        <p>These Terms are governed by the laws of the State of Ohio, USA. Any disputes will be resolved in the state or federal courts located in Ohio.</p>

        <h2>15. Contact</h2>
        <p>Questions? Email <a href="mailto:info@childcheckoh.com">info@childcheckoh.com</a>.</p>
      </main>
      <Footer />
    </div>
  );
}
